import { render, staticRenderFns } from "./ContractsOngoingClosedChart.vue?vue&type=template&id=0facce53&scoped=true"
import script from "./ContractsOngoingClosedChart.vue?vue&type=script&lang=js"
export * from "./ContractsOngoingClosedChart.vue?vue&type=script&lang=js"
import style0 from "./ContractsOngoingClosedChart.vue?vue&type=style&index=0&id=0facce53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facce53",
  null
  
)

export default component.exports